// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Table(Props) {
  var children = Props.children;
  var className = Props.className;
  return React.createElement("table", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "table",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* [] */0
                    ]
                  ])
            }, children);
}

var make = Table;

exports.make = make;
/* react Not a pure module */
